var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "#22E06C",
    viewBox: "4 4 24 24",
    enableBackground: "new 4 4 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__turn_on"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    d: "M16,28c6.627,0,12-5.373,12-12S22.627,4,16,4C9.373,4,4,9.373,4,16S9.373,28,16,28z M14.853,17.253V8h2.295 v9.253H14.853z M8,16c0-2.21,0.895-4.209,2.343-5.657l1.611,1.611c-1.036,1.035-1.676,2.466-1.676,4.046 c0,3.16,2.562,5.722,5.722,5.722c3.16,0,5.723-2.562,5.723-5.722c0-1.58-0.641-3.011-1.677-4.046l1.611-1.611 C23.105,11.791,24,13.79,24,16c0,4.418-3.582,7.999-8,7.999C11.582,23.999,8,20.418,8,16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnon);
export default __webpack_public_path__ + "static/media/turnon.57a00137ab43dcec2c0d46121e0b30ba.svg";
export { ForwardRef as ReactComponent };